module.exports = __webpack_public_path__ + "media/images/dingdong-f33f9d0375904c27eb13618d9e683293.png";